export default __webpack_public_path__ + "static/media/330_dummy2016-restaurant04-mobile-de.77ed2190.png";